import { NavLink } from "react-router-dom";

export const Sidebar = ({ isOpen }) => {
    return (
        <>
            <aside
                className={`
                    fixed top-[55px] left-0 
                    w-[50px] min-h-[calc(100vh-55px)]
                    bg-[linear-gradient(145deg,#343a40,#1d2124)]
                    transition-transform duration-300
                    ${isOpen ? "translate-x-0" : "-translate-x-full"}
            `}
            >
                <NavLink
                    to="/manage/feeder"
                    className="group relative"
                    style={({ isActive }) => ({
                        color: isActive ? "#20a8d8" : "#73818f"
                    })}
                >
                    <span className="flex justify-center items-center w-[50px] h-[50px] icon-basket text-[18px]"></span>
                </NavLink>
            </aside>
            <div
                className={`
                    bg-[linear-gradient(145deg,#343a40,#1d2124)]
                    transition-all duration-300
                    ${isOpen ? "w-[50px]" : "w-0"}
                `}
            />
        </>
    );
}